export default "__VITE_ASSET__75d85c21__"